import { Star, BadgeCheck, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const GOOGLE_PROFILE_URL =
  "https://www.google.com/maps/search/?api=1&query=A.S.F+Viagens+LTDA+Cuiab%C3%A1";

const TESTIMONIALS = [
  {
    name: "Mariana Souza",
    service: "Passagens Aéreas",
    text: "Comprei minha passagem para Lisboa com a A.S.F e economizei quase 30% em relação aos sites de busca. Atendimento impecável do início ao fim.",
  },
  {
    name: "Carlos Pereira",
    service: "Western Union",
    text: "Recebo dinheiro da minha filha que mora nos EUA todo mês. Na A.S.F o processo leva minutos e as taxas são as melhores que encontrei.",
  },
  {
    name: "Ana Beatriz Lima",
    service: "Naturalização",
    text: "A assessoria para minha cidadania brasileira foi fundamental. Cada documento foi revisado com cuidado e hoje sou oficialmente brasileira!",
  },
  {
    name: "João Ricardo",
    service: "DHL Express",
    text: "Precisava enviar documentos urgentes para a Alemanha. Chegaram em 3 dias úteis com rastreamento em tempo real. Impressionante.",
  },
  {
    name: "Fernanda Costa",
    service: "Passagens Aéreas",
    text: "Emitiram passagens para Miami para toda a família. Quando precisei trocar a data, resolveram tudo em uma única ligação.",
  },
  {
    name: "Mohamed Haddad",
    service: "Naturalização",
    text: "Sou sírio e a equipe me acompanhou em todo o processo de naturalização. Profissionalismo e humanidade que não encontrei em outro lugar.",
  },
];

const Stars = () => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-gold text-gold" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section
    id="depoimentos"
    data-testid="testimonials-section"
    className="bg-sand py-20 lg:py-32"
  >
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold-bronze mb-5">
          Depoimentos
        </p>
        <div className="flex items-center justify-center gap-4">
          <span
            data-testid="testimonials-rating"
            className="font-serif text-5xl sm:text-6xl font-bold text-navy"
          >
            5.0
          </span>
          <div className="text-left">
            <Stars />
            <p className="mt-1 text-sm text-slate-600">
              Mais de 1.200 clientes atendidos com excelência
            </p>
          </div>
        </div>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.08}>
            <article
              data-testid={`testimonial-card-${i + 1}`}
              className="relative h-full bg-ivory rounded-2xl p-7 border border-navy/5 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gold/25" />
              <Stars />
              <p className="mt-5 text-sm sm:text-base text-slate-700 leading-relaxed">
                “{t.text}”
              </p>
              <div className="mt-6 flex items-center justify-between gap-3">
                <div>
                  <p className="font-semibold text-navy text-sm">{t.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold-bronze mt-1">
                    {t.service}
                  </p>
                </div>
                <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1">
                  <BadgeCheck className="w-3.5 h-3.5" />
                  Verificado
                </span>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 text-center">
        <a
          href={GOOGLE_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-review-button"
          className="inline-flex items-center gap-2.5 bg-navy text-ivory font-semibold text-sm px-8 py-4 rounded-full hover:bg-gold hover:text-navy transition-all duration-300 shadow-lg"
        >
          <Star className="w-4 h-4 fill-current" />
          Avalie-nos no Google
        </a>
        <p className="mt-4 text-xs text-slate-500">
          Sua avaliação no perfil da A.S.F Viagens ajuda outros clientes a confiar na gente.
        </p>
      </Reveal>
    </div>
  </section>
);
